export default {
  isLoading: false,
  isClosed: true,
  search: "",
  timeFilters: [
    {
      level: 0,
      count: 0,
      status: true
    },
    {
      level: 1,
      count: 0,
      status: false
    },
    {
      level: 2,
      count: 0,
      status: false
    },
    {
      level: 3,
      count: 0,
      status: false
    }
  ],
  list: [],
  // ===============================================
  live: {
    search: "",
    isDefault: true,
    timeFilters: [
      {
        level: 0,
        count: 0,
        status: true
      },
      {
        level: 1,
        count: 0,
        status: false
      },
      {
        level: 2,
        count: 0,
        status: false
      },
      {
        level: 3,
        count: 0,
        status: false
      }
    ],
    statFilters: [
      {
        key: "teamTotals",
        title: "T's",
        status: false
      },
      {
        key: "maxGoal",
        title: "MG",
        status: false
      },
      {
        key: "timeLevels",
        title: "L's",
        status: false
      },
      {
        key: "totalOver",
        title: "2O",
        status: false
      },
      {
        key: "favourite",
        title: "2F",
        status: false
      }
    ],
    settings: {
      default: [
        {
          key: "statLevels",
          title: "Stat levels",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3"],
            subtitles: [
              "Dangerous Attack",
              "Shots On Goal",
              "Shots Off Goal",
              "Shots"
            ],
            values: [[12, 2, 4, 0], [35, 4, 6, 0], [50, 6, 8, 0]]
          }
        },
        {
          key: "timeLevels",
          title: "Time levels",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3"],
            subtitles: ["From", "To"],
            values: [[10, 23], [64, 70], [71, 80]]
          }
        },
        {
          key: "teamTotals",
          title: "Team totals",
          settings: {
            titles: [],
            subtitles: ["Recent 3", "Recent 10"],
            values: [[0.7, 1.4]]
          }
        },
        {
          key: "smPercent",
          title: "SM percent",
          settings: {
            titles: [],
            subtitles: ["Percent, %"],
            values: [[23]]
          }
        },
        {
          key: "totalOver",
          title: "Total over",
          settings: {
            titles: [],
            subtitles: ["Totals"],
            values: [["2/2.5, 2.5, 2.5/3, 3, 3/3.5"]]
          }
        },
        {
          key: "2HalfFastGoals", // TODO add filter processing
          title: "2Half fast goals",
          settings: {
            titles: ["Time", "Goals", "Status", "First goal exception"],
            subtitles: ["From", "To"],
            values: [[48, 70], [1], [true], [true]]
          }
        },
        {
          key: "missMatchScore",
          title: "Miss match score",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3", "Status"],
            subtitles: ["Score", "Exception"],
            values: [
              ["1-0, 0-1, 1-1, 2-0, 0-2, 2-1, 1-2, 3-0, 0-3", 0],
              ["1-1", 1.79],
              ["", 0],
              [true]
            ]
          }
        },
        {
          key: "maxGoal",
          title: "Max goal",
          settings: {
            titles: [],
            subtitles: ["Goals"],
            values: [[3]]
          }
        },
        {
          key: "noRedCards",
          title: "No red cards",
          settings: {
            titles: ["Status", "Favourite Exception"],
            subtitles: [],
            values: [[true], [1.79]]
          }
        },
        {
          key: "overratedMatches",
          title: "Overrated matches",
          settings: {
            titles: ["Status", "Total"],
            subtitles: [],
            values: [[true], [4]]
          }
        }
      ],
      list: []
    }
  },
  dadbee: {
    search: "",
    isDefault: true,
    timeFilters: [
      {
        level: 0,
        count: 0,
        status: true
      },
      {
        level: 1,
        count: 0,
        status: false
      },
      {
        level: 2,
        count: 0,
        status: false
      },
      {
        level: 3,
        count: 0,
        status: false
      }
    ],
    statFilters: [
      {
        key: "teamTotals",
        title: "T's",
        status: false
      },
      {
        key: "maxGoal",
        title: "MG",
        status: false
      },
      {
        key: "timeLevels",
        title: "L's",
        status: false
      },
      {
        key: "totalOver",
        title: "2O",
        status: false
      },
      {
        key: "favourite",
        title: "2F",
        status: false
      }
    ],
    settings: {
      default: [
        {
          key: "statLevels",
          title: "Stat levels",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3"],
            subtitles: [
              "Dangerous Attack",
              "Shots On Goal",
              "Shots Off Goal",
              "Shots"
            ],
            values: [[12, 2, 4, 0], [35, 4, 6, 0], [50, 6, 8, 0]]
          }
        },
        {
          key: "timeLevels",
          title: "Time levels",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3"],
            subtitles: ["From", "To"],
            values: [[10, 23], [64, 70], [71, 80]]
          }
        },
        {
          key: "teamTotals",
          title: "Team totals",
          settings: {
            titles: [],
            subtitles: ["Recent 3", "Recent 10"],
            values: [[0.7, 1.4]]
          }
        },
        {
          key: "smPercent",
          title: "SM percent",
          settings: {
            titles: [],
            subtitles: ["Percent, %"],
            values: [[23]]
          }
        },
        {
          key: "totalOver",
          title: "Total over",
          settings: {
            titles: [],
            subtitles: ["Totals"],
            values: [["2/2.5, 2.5, 2.5/3, 3, 3/3.5"]]
          }
        },
        {
          key: "2HalfFastGoals", // TODO add filter processing
          title: "2Half fast goals",
          settings: {
            titles: ["Time", "Goals", "Status", "First goal exception"],
            subtitles: ["From", "To"],
            values: [[48, 70], [1], [true], [true]]
          }
        },
        {
          key: "missMatchScore",
          title: "Miss match score",
          settings: {
            titles: ["Level 1", "Level 2", "Level 3", "Status"],
            subtitles: ["Score", "Exception"],
            values: [
              ["1-0, 0-1, 1-1, 2-0, 0-2, 2-1, 1-2, 3-0, 0-3", 0],
              ["1-1", 1.79],
              ["", 0],
              [true]
            ]
          }
        },
        {
          key: "maxGoal",
          title: "Max goal",
          settings: {
            titles: [],
            subtitles: ["Goals"],
            values: [[3]]
          }
        },
        {
          key: "noRedCards",
          title: "No red cards",
          settings: {
            titles: ["Status", "Favourite Exception"],
            subtitles: [],
            values: [[true], [1.79]]
          }
        },
        {
          key: "overratedMatches",
          title: "Overrated matches",
          settings: {
            titles: ["Status", "Total"],
            subtitles: [],
            values: [[true], [4]]
          }
        }
      ],
      list: []
    }
  }
};
